export default "__VITE_ASSET__TcewoKRQ__"